<script lang="ts">
	import { nbspify } from "../../../core/utils/nbspify";
	import StaticPicture from "./Picture/StaticPicture.svelte";

	interface ImageSizes {
		sm?: string;
		md?: string;
		lg: string;
	}

	interface Image {
		alt: string;
		sizes: ImageSizes;
	}

	export let headline: string;
	export let subheadlineClasses: string | undefined = undefined;
	export let subHeadline: string | undefined = undefined;
	export let image: Image;
	export let isPageHeading = false;
</script>

<div
	class="narrow-container flex flex-col items-center gap-10 overflow-hidden py-8 sm:py-12 md:py-16 lg:flex-row lg:gap-6 lg:p-10"
>
	<div class="flex flex-col justify-center text-center lg:basis-[calc(50%-.75rem)] lg:justify-start lg:text-left">
		{#if isPageHeading}
			<h1 class="decorative-headline !mx-0 !mb-6 lg:!text-left">{nbspify(headline)}</h1>
		{:else}
			<span class="decorative-headline !mx-0 !mb-6 lg:!text-left">{nbspify(headline)}</span>
		{/if}
		{#if subHeadline}
			<h2 class="h2 mb-8 !text-lg lg:!text-xl {subheadlineClasses}">{nbspify(subHeadline)}</h2>
		{/if}
		<slot />
	</div>
	<StaticPicture
		class="relative h-[20rem] w-full max-w-[25rem] min-[400px]:h-[25rem] md:h-[27rem] md:max-w-[27rem] lg:h-[31rem] lg:max-w-[31rem] lg:basis-[calc(50%-.75rem)]"
		imgClass="w-full max-h-full rounded-lg object-cover m-auto inset-0 absolute"
		image={image.sizes.lg}
		width={496}
		height={496}
		loading="lazy"
		alt="Fotografie – ukázka svatebního dortu"
		sourcesets={{
			"<md": image.sizes.sm ?? image.sizes.lg,
			"<lg": image.sizes.md ?? image.sizes.lg,
			">lg": image.sizes.lg,
		}}
	/>
</div>
